import React, { useState } from 'react'
import { useRef } from 'react';
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { ControlLabel, FormGroup, Input, InputPicker, SelectPicker, FormControl } from 'rsuite';
import { getAdditionalStructurals, getEngineerExamDiscipline, getFirstExamDiscipline, getStates } from '../../../../services/Shared/codeTable.service';
import YesNoRadioOption from '../../../Shared/RadioButton/YesNoRadioOption';

function PeEiAdditionalInformationSection() {
    const [appDiscipline, setAppDiscipline] = useState([]);
    const [states, setStates] = useState([])
    const [examDiscipline, setExamDiscipline] = useState([])
    const [additionalStructurals, setAdditionalStructurals] = useState([])
    const stateSearch = (userInput, label, dataItem) => {
        if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput)
            return true;
    }
    useEffect(() => {
        getStates().then(setStates);
        getEngineerExamDiscipline().then(setExamDiscipline);
        getFirstExamDiscipline().then(setAppDiscipline);
        getAdditionalStructurals().then(setAdditionalStructurals);
    }, [])


    return (
        <>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Application Disc.</b></ControlLabel>
                        <FormControl
                            name="applicationDiscipline"
                            data={appDiscipline}
                            accepter={SelectPicker}
                            searchable={false}
                            block
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Comity State</b></ControlLabel>
                        <FormControl
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="comityState" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>EI Cert. Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="eiCertificationDate"
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>EI Cert. #</b></ControlLabel>
                        <FormControl name="eiCertificationNumber" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>FE Exam Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="feExamDate"
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>FE Exam State</b></ControlLabel>
                        <FormControl
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="feExamState" />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>PE Exam Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="peExamDate"
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>PE Exam State</b></ControlLabel>
                        <FormControl
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="peExamState" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>PE Lic State</b></ControlLabel>
                        <FormControl
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="peLicenseState" />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>PE Lic Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="peLicenseDate"
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>PE Lic #</b></ControlLabel>
                        <FormControl name="peLicenseNumber" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>PE Exam Discipline</b></ControlLabel>
                        <FormControl
                            name="peExamDiscipline"
                            data={examDiscipline}
                            accepter={InputPicker}
                            searchable={true}
                            block
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Discipline 2</b></ControlLabel>
                        <FormControl
                            name="peExamDiscipline2"
                            data={appDiscipline}
                            accepter={InputPicker}
                            searchable={true}
                            block
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Dis. 2 Reg. Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="peExamDiscipline2RegistrationDate"
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Dis. 2 Exam State</b></ControlLabel>
                        <FormControl
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="peExamDiscipline2ExamState" />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Model Law</b></ControlLabel>
                        <YesNoRadioOption radioName="isModelLaw" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Act 2</b></ControlLabel>
                        <YesNoRadioOption radioName="isAct2" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>PE by Endorsement</b></ControlLabel>
                        <YesNoRadioOption radioName="isByEndorsement" />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Additional Structural</b></ControlLabel>
                        <FormControl
                            accepter={InputPicker}
                            block
                            data={additionalStructurals}
                            searchBy={stateSearch}
                            name="additionalStructural1" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Additional Structural Exam Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="additionalStructuralExamDate1"
                        />
                    </FormGroup>
                </Col>
                <Col>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Additional Structural</b></ControlLabel>
                        <FormControl
                            accepter={InputPicker}
                            block
                            data={additionalStructurals}
                            searchBy={stateSearch}
                            name="additionalStructural2" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Additional Structural Exam Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="additionalStructuralExamDate2"
                        />
                    </FormGroup>
                </Col>
                <Col>
                </Col>
            </Row>
        </>
    );
}
export default PeEiAdditionalInformationSection;